export default __webpack_public_path__ + "static/IN-9008HD-vs-IN-5907HD-781019d35c9daf2a75e42079dfe37745.webp";